import ActionType from 'actions/ActionType'

export default (
  state = { name: '', description: '', start_date: null, end_date: null },
  action,
) => {
  switch (action.type) {
    case ActionType.Campaign.RECEIVE_CAMPAIGN:
      return {
        name: action.payload ? action.payload.name : '',
        description:
          action.payload && action.payload.description
            ? action.payload.description
            : '',
        start_date:
          action.payload && action.payload.start_date
            ? new Date(action.payload.start_date)
            : null,
        end_date:
          action.payload && action.payload.end_date
            ? new Date(action.payload.end_date)
            : null,
      }
    case ActionType.Campaign.CHANGE_FIELD:
      if (
        action.payload &&
        (action.payload.name === 'start_date' ||
          action.payload.name === 'end_date') &&
        typeof action.payload.value === 'number'
      ) {
        return {
          ...state,
          [action.payload.name]: new Date(action.payload.value),
        }
      }
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      }
    case ActionType.Campaign.TOGGLE_DATE_RANGE:
      return { ...state, start_date: null, end_date: null }
    case ActionType.Campaign.INGEST_PREDICTION:
      const nameEntityArr = action.payload.filter(
        (el) => el.type === 'CAMPAIGN_NAME',
      )
      if (nameEntityArr.length) {
        return {
          ...state,
          name: nameEntityArr[0].entity,
        }
      }
      return state
    default:
      return state
  }
}
